import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-tke-loader',
  templateUrl: './tke-loader.component.html',
  styleUrls: ['./tke-loader.component.css']
})
export class TkeLoaderComponent {

  @Input('isLoading') public isLoading;
  constructor() { }


}
